import React, {Fragment, Suspense} from 'react';
import MasterLayout from "../../components/MasterLayout/MasterLayout";
import LazyLoader from "../../components/MasterLayout/LazyLoader";
import WarehouseCreate from '../../components/Warehouse/WarehouseCreate';

const WarehouseCreatePage = () => {
    return (
        <Fragment>
            <MasterLayout>
                <Suspense fallback={<LazyLoader/>}>
                    <WarehouseCreate/>
                </Suspense>
            </MasterLayout>
        </Fragment>
    );
};

export default WarehouseCreatePage;